import sortBy from 'lodash/sortBy';
import { DEFAULT_GROUP_DATA, GROUPS_SORT_BY, GROUPS_COVER_COLORS } from 'constants';
import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  data: [],
  error: null,
  loading: false,
  sortBy: GROUPS_SORT_BY[0].value,
  groupDetails: {
    data: {},
    loading: true,
  },
  coverColor: GROUPS_COVER_COLORS[0],
  editCoverModeOn: false,
  addedToGroup: 0,
};

const mapOrdersList = ({ groups, defaultStats }) => {
  const defaultGroup = Object.assign({}, DEFAULT_GROUP_DATA, defaultStats);
  return [defaultGroup, ...groups];
};

const mapGroupsListV2 = ({ groups, isDefaultGroupsOnly }) => {
  let orderedGroups = groups;

  if (isDefaultGroupsOnly) {
    orderedGroups = orderedGroups.filter(({ defaultGroup }) => defaultGroup);
  }

  // move default group at the beginning of group list
  return sortBy(orderedGroups, ({ defaultGroup }) => !defaultGroup);
};

const groups = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_GROUPS_LOADING:
    case actionTypes.CREATE_GROUP_LOADING:
    case actionTypes.EDIT_GROUP_LOADING:
    case actionTypes.EDIT_GROUP_COVER_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.GET_GROUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload.isApiV2 ? mapGroupsListV2(payload) : mapOrdersList(payload),
      };

    case actionTypes.RESET_CLIENT_GROUPS:
      return {
        ...state,
        loading: false,
        data: [],
      };

    case actionTypes.GET_GROUPS_ERROR:
    case actionTypes.CREATE_GROUP_ERROR:
    case actionTypes.EDIT_GROUP_ERROR:
    case actionTypes.EDIT_GROUP_COVER_ERROR:
    case actionTypes.DELETE_GROUP_ERROR:
    case actionTypes.GROUP_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case actionTypes.CREATE_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        editCoverModeOn: false,
      };
    case actionTypes.EDIT_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        editCoverModeOn: false,
        groupDetails: {
          ...state.groupDetails,
          loading: false,
          data: payload,
        },
      };
    case actionTypes.GROUP_DETAILS_LOADING:
    case actionTypes.DELETE_GROUP_LOADING:
      return {
        ...state,
        error: null,
        groupDetails: {
          ...state.groupDetails,
          loading: true,
        },
      };
    case actionTypes.GROUP_DETAILS_SUCCESS:
      return {
        ...state,
        groupDetails: {
          ...state.groupDetails,
          data: payload,
          loading: false,
        },
        editCoverModeOn: false,
      };
    case actionTypes.GROUP_DETAILS_RESET:
    case actionTypes.DELETE_GROUP_SUCCESS:
      return {
        ...state,
        groupDetails: {
          data: {},
          loading: true,
        },
      };
    case actionTypes.EDIT_GROUP_COVER_MODE_RESET:
      return {
        ...state,
        loading: false,
        editCoverModeOn: false,
        coverColor: GROUPS_COVER_COLORS[0],
      };
    case actionTypes.EDIT_GROUP_COVER_SUCCESS:
      return {
        ...state,
        loading: false,
        coverColor: payload,
        editCoverModeOn: true,
      };
    case actionTypes.ADD_TO_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.GROUPS_SORT_BY:
      return {
        ...state,
        sortBy: payload,
      };
    default:
      return state;
  }
};

export default groups;
